<div class="start-page">
  <section class="intro">
    <img class="logo" src="images/logo.png" alt="Coverage Validator" />
    <div>
      <p class="bold text-cvgreen">Automated Inspections</p>
      <h1>Validate your coverage in minutes, not weeks.</h1>
    </div>
    <p class="lead">
      Coverage Validator replaces the on-site contractor inspection with a guided self-survey.
      Confirm the information on your application, correct what has changed, and keep your liability
      policy in force.
    </p>
    <ol class="steps">
      <li>
        <span class="step-number">1</span>
        <div>
          <p class="bold">Confirm what's on file</p>
          <p>Review the business, classifications and addresses from your application.</p>
        </div>
      </li>
      <li>
        <span class="step-number">2</span>
        <div>
          <p class="bold">Correct what changed</p>
          <p>Update operations, percentage of work, payroll and receipts in one pass.</p>
        </div>
      </li>
      <li>
        <span class="step-number">3</span>
        <div>
          <p class="bold">Keep your policy in force</p>
          <p>Finish inside 3 days and your inspection never leaves the automated track.</p>
        </div>
      </li>
    </ol>
  </section>

  <section class="access">
    <div class="card">
      @if (store.link(); as link) {
        <p class="bold">Is This You?</p>
        <h2 class="business-name">{{ link.businessName }}</h2>
        <div class="details">
          <p>
            Policy {{ link.policyNumber }} &middot; General Liability<br />{{ link.productName }}
          </p>
          <p>
            Confirm and we'll send a one-time code to<br />
            <span class="bold text-cvnavy">{{ link.maskedEmail }}</span>.
          </p>
        </div>

        @if (!store.codeSent()) {
          <lib-buttons text="Confirm" size="full" (click)="store.sendCode()" />
        } @else {
          <div class="code-sent" role="status">Code Sent <lib-icons icon="check" /></div>
          <form class="verify-row" [formGroup]="form" (ngSubmit)="verify()">
            <lib-form-text
              formControlName="code"
              placeholder="6-digit code"
              ariaLabel="6-digit code"
              mask="000000"
              autocomplete="one-time-code"
              [hideRequiredMarker]="true"
              [customErrors]="{ required: 'Enter your code', minlength: 'Enter all 6 digits' }"
            />
            <lib-buttons type="submit" cssType="btn-secondary" text="Verify" />
          </form>
          <lib-buttons cssType="btn-link" size="small" text="Send a new code" (click)="store.sendCode()" />
        }
      } @else if (!store.error()) {
        <p>Loading your inspection...</p>
      }

      @if (store.error()) {
        <p class="small error" role="alert">{{ store.error() }}</p>
      }
    </div>
  </section>
</div>
